import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/components/_popup.scss.js';
import { createPortal } from 'react-dom';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import usePortal from '../../hooks/use-portal/use-portal.js';
import Overlay from '../overlay/overlay.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('popup', styles);
var Popup = function (_a) {
  var id = _a.id,
    active = _a.active,
    children = _a.children,
    extraClasses = _a.extraClasses,
    portalId = _a.portalId,
    onOverlayClick = _a.onOverlayClick,
    rest = __rest(_a, ["id", "active", "children", "extraClasses", "portalId", "onOverlayClick"]);
  var target = portalId && usePortal(portalId);
  /**
   * Makes popup listen to ESC button press to call the onClose callback using the keyboard.
   */
  var handleEscape = function (event) {
    if (onOverlayClick && event.key === 'Escape') {
      onOverlayClick(event);
    }
  };
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  var popup = /*#__PURE__*/React__default__default.createElement("div", __assign({
    id: id,
    role: "dialog",
    "aria-modal": "true",
    className: bem.b({
      active: active
    }, extraClasses),
    onKeyDown: handleEscape
  }, !active && {
    hidden: true
  }, rest), /*#__PURE__*/React__default__default.createElement("div", {
    className: bem.e('body')
  }, children), /*#__PURE__*/React__default__default.createElement(Overlay, {
    onClick: onOverlayClick
  }));
  return target ? /*#__PURE__*/createPortal(popup, target) : popup;
};
Popup.displayName = 'Popup';
Popup.defaultProps = {
  id: null,
  active: false,
  extraClasses: '',
  onOverlayClick: null,
  portalId: null
};
Popup.propTypes = {
  id: PropTypes__default.string,
  active: PropTypes__default.bool,
  extraClasses: PropTypes__default.string,
  onOverlayClick: PropTypes__default.func,
  portalId: PropTypes__default.string,
  children: PropTypes__default.node.isRequired
};
var popup = Injecss(Popup, styles);

export { Popup, popup as default };
